import axios from 'axios'
import {errorHelper, messageHelper} from '../helper.js'
import { GET_LIST_ARCHIVE_URL, PATCH_LIST_ARCHIVE_URL } from '../../../vars'

export default {
    state: {
       archiveProposal: []
    },
    mutations: {
        UPDATE_ARCHIVE_PROPOSAL(state, data) {
            state.archiveProposal =  data
        }
    },
    actions: {
        
        async GET_ARCHIVE_PROPOSAL(ctx) {

            try {

                const res = await axios.get(`${GET_LIST_ARCHIVE_URL}?page=1`, { 
                    headers: {
                      Authorization: `Token ${localStorage.token}`
                }});
                
                await ctx.commit('UPDATE_ARCHIVE_PROPOSAL', res.data)

            } catch(e) {

                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                throw e

            }

        },

        async ADD_ARCHIVE_PROPOSAL(ctx, data) {

            try {

                const res = await axios.patch(PATCH_LIST_ARCHIVE_URL, data, { 
                    headers: {
                      Authorization: `Token ${localStorage.token}`
                }});

                return res.status

            } catch(e) {

                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                throw e

            }

        }

    },
    getters: {
        GETTERS_ARCHIVE_PROPOSAL(state) {
            return state.archiveProposal
        }
    }
}